import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTasks = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 27,
	viewBox: "0 0 28 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.6398 26.2206H0.783548V16.3276H9.95218V20.7524C9.95218 20.9682 10.1308 21.1414 10.3507 21.1414H17.2101C17.4163 21.1414 17.5949 20.9682 17.5949 20.7524V16.3276H26.6398V26.2206ZM5.78703 0.7808H21.9525L26.5023 15.5482H16.8114L17.5949 16.3276C17.7065 16.0312 16.8114 15.5482 16.8114 15.5482V20.3634H10.7356V15.9372C10.7356 15.7227 10.5569 15.5482 10.3507 15.5482H0.934701L5.78703 0.7808ZM27.3958 15.8808V15.8231L22.6122 0.274921C22.571 0.111343 22.406 0 22.2411 0H5.49841C5.33346 0 5.18223 0.108589 5.12724 0.269417L0.0275157 15.8162L0.0136891 15.8767L-3.21865e-06 15.9372V26.611C-3.21865e-06 26.8254 0.178749 27 0.398686 27H27.0247C27.2446 27 27.4097 26.8254 27.4097 26.611V15.9372L27.3958 15.8808Z",
		fill: "#272525"
	})
});
export { SvgTasks as ReactComponent };
